export const environment = {
    production: false,
    app_id:"guw-dev",
    clarityProjectId: 'wj5t50loaw',
    api_url: "https://gs-uwportal-apim.azure-api.net/v1/dev/",
    tenant_id: "ad73e3ae-e8d2-40cd-98d8-d5f9c566cb19",
    progress_api_url: "https://progress-tracker-dev-as.azurewebsites.net/",
    notificationUrl: 'https://bp-dev-apim.azure-api.net/notification-dev/',
    platformUrl: "https://bp-dev-apim.azure-api.net/pf-dev/",
    emailUrl: "https://bp-dev-apim.azure-api.net/pf-user/",
    googleMapsApiKey: "AIzaSyCfuzGZDnLxP4xfZy_PuyiWNGQykmT2Lbo",
    restrictedEmailDomains: ['gmail.com','yahoo.com','hotmail.com','outlook.com'],
    platformSupportUrl: 'https://bp-dev-apim.azure-api.net/pf-dev-lib/',
    docsApiKey: "AIzaSyBgL3hkdikgPUYEjUm0PnB9lHx72daQVA4",
    docsBaseUrl: "api.compass.greenshieldrisk.com",
    auGoldURL: "https://login.augold.net/login",
};
